module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_library.js
// module id = 47
// module chunks = 0 2 3 4 5 6 7 8 11 12 13 14 15 16 17 18 20